module.exports = __webpack_public_path__ + "static/media/E34.a5ad5651.jpg";